import { Box, Flex, Text } from '@chakra-ui/react';

/**
 * A visual representation component to help users understand various UI symbols or indicators.
 *
 * @component
 *
 * @returns {ReactElement} The Legend component.
 */
export const Legend = () => {
  return (
    <Flex direction='column' alignSelf='start' gap={1} mt={4}>
      <Text fontSize='s' color='text.faded'>
        Legend
      </Text>
      <Flex align='center' gap={1}>
        <Box boxSize={1.5} bg='tealishBlue' />
        <Text fontSize='s' color='text.faded'>
          Forecasted Value
        </Text>
      </Flex>
    </Flex>
  );
};
